// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ddpd","type":"styles_type__2DpM2","choices":"styles_choices__3FbPN"};